import { render, staticRenderFns } from "./TeamEventView.vue?vue&type=template&id=7a4988d2&"
import script from "./TeamEventView.vue?vue&type=script&lang=ts&"
export * from "./TeamEventView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports